import * as React from 'react';

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  withStyles,
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core';

import { quantifyBins, Histogram } from '../utils';

type Classes = Record<string, string | undefined>;

interface Props {
  bins: NdviRasterBins;
  histogram: Histogram;
  totalArea: number;
  dense?: boolean;
  fractionDigits?: number;
  suffix?: string;
}

const styles: StyleRulesCallback = theme => ({
  dataRow: {
    height: theme.typography.fontSize
  },
  dataCell: {
    padding: theme.spacing.unit
  },
  colorSquare: {
    width: 16,
    height: 16,
    border: '1px solid #888'
  }
});

class LegendControl extends React.PureComponent<Props & WithStyles> {
  renderRow(
    bin: QuantifiedBin,
    classes: Classes,
    fractionDigits: number = 2,
    suffix: string | null = null
  ) {
    return (
      <TableRow key={bin.color} className={classes.dataRow}>
        <TableCell className={classes.dataCell} numeric={true}>
          <div
            className={classes.colorSquare}
            style={{ backgroundColor: bin.color }}
          />
        </TableCell>
        <TableCell className={classes.dataCell} numeric={true}>
          {bin.min.toFixed(fractionDigits)}
          {suffix}
        </TableCell>
        <TableCell className={classes.dataCell} numeric={true}>
          {bin.max.toFixed(fractionDigits)}
          {suffix}
        </TableCell>
        <TableCell className={classes.dataCell} numeric={true}>
          {bin.area.toFixed(0)}
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const {
      classes,
      bins,
      histogram,
      totalArea,
      dense,
      fractionDigits,
      suffix
    } = this.props;

    const quantifiedBins = quantifyBins(bins, histogram, totalArea);

    const finalClasses = {
      colorSquare: classes.colorSquare,
      dataRow: dense ? classes.dataRow : undefined,
      dataCell: dense ? classes.dataCell : undefined
    };

    return (
      <Table>
        <TableHead>
          <TableRow className={finalClasses.dataRow}>
            <TableCell className={finalClasses.dataCell} numeric={true}>
              Color
            </TableCell>
            <TableCell className={finalClasses.dataCell} numeric={true}>
              Min
            </TableCell>
            <TableCell className={finalClasses.dataCell} numeric={true}>
              Max
            </TableCell>
            <TableCell className={finalClasses.dataCell} numeric={true}>
              Area
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quantifiedBins.map(bin =>
            this.renderRow(bin, finalClasses, fractionDigits, suffix)
          )}
        </TableBody>
      </Table>
    );
  }
}

export default withStyles(styles)(LegendControl);



// WEBPACK FOOTER //
// ./src/components/BinLegend.tsx